var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerDiv"},[_c('PCNavbar',{attrs:{"selectIndex":"CgList"}}),_c('MobileNavBar',{attrs:{"currentActive":7}}),_c('img',{staticClass:"bannerImgcss0",attrs:{"src":require("../assets/caigouxinxi/caigouxinxiBanner.png")}}),_c('list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }